/* eslint-disable @typescript-eslint/no-require-imports */

export const IllusBowl = require('./Illus-Bowl.png');
export const IllusPlate = require('./Illus-Plate.png');
